module.exports = __webpack_public_path__ + "img/Layer-10.187170a9.webp";